"use client";

import { useState, type ReactNode } from "react";
import { HiOutlineAdjustmentsHorizontal } from "react-icons/hi2";
import { IoMdClose } from "react-icons/io";

/**
 * Below lg: floating "Filters" button (fixed, like courses/fun dives) that
 * opens the filters in an overlay panel. On lg+: renders children inline so
 * the parent <aside> can keep them as a sticky sidebar.
 */
export default function LiveaboardFiltersFab({ children }: { children: ReactNode }) {
  const [showFilters, setShowFilters] = useState(false);

  return (
    <>
      <button
        className={`
          lg:hidden
          fixed z-[45]
          left-4
          top-[var(--nav-fab-offset,10.5rem)]
          bg-white hover:bg-gray-100
          text-gray-800
          px-4 py-2
          rounded-full shadow-lg
          flex items-center gap-2
          transition-all
          border border-gray-300
          ${showFilters ? "opacity-0 pointer-events-none" : "opacity-100"}
        `}
        onClick={() => setShowFilters(true)}
      >
        <HiOutlineAdjustmentsHorizontal size={18} />
        <span className="ml-2 hidden md:block">Filters</span>
      </button>

      <div
        className={`${
          showFilters ? "fixed inset-0 z-50 bg-black bg-opacity-50" : "hidden"
        } lg:static lg:block lg:bg-transparent`}
        onClick={() => setShowFilters(false)}
      >
        <div
          className="absolute left-4 right-4 md:right-auto md:w-96 top-[var(--nav-fab-offset,10.5rem)] h-[calc(100vh-var(--nav-fab-offset,10.5rem)-1rem)] min-h-0 overflow-hidden lg:static lg:w-auto lg:h-auto lg:overflow-visible"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex h-full min-h-0 flex-col rounded-xl bg-white shadow-xl lg:h-auto lg:flex-none lg:rounded-none lg:bg-transparent lg:shadow-none">
            <div className="lg:hidden flex items-center justify-between px-4 py-3 border-b border-neutral-200">
              <span className="font-semibold text-neutral-800 flex items-center gap-2">
                <HiOutlineAdjustmentsHorizontal size={18} />
                Filters
              </span>
              <button
                onClick={() => setShowFilters(false)}
                aria-label="Close filters"
                className="rounded-full p-1 text-neutral-500 hover:bg-neutral-100 hover:text-neutral-800 transition"
              >
                <IoMdClose size={20} />
              </button>
            </div>
            <div className="flex-1 min-h-0 overflow-y-auto p-4 lg:flex-none lg:overflow-visible lg:p-0">
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
